import { useLocation, Link } from "react-router-dom";
import { Mail, ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { APP_NAME } from "@/lib/constants";

const VerificationPending = () => {
  const location = useLocation();
  const email = location.state?.email || "האימייל שלך";

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 text-center" dir="rtl">
      
      <div className="w-full max-w-md space-y-8">
        {/* Brand */}
        <Link to="/" className="text-2xl font-bold text-slate-900 tracking-tight block mb-12">
          {APP_NAME}
        </Link>

        {/* Icon */}
        <div className="relative w-24 h-24 mx-auto">
          <div className="absolute inset-0 bg-blue-100 rounded-full animate-pulse" />
          <div className="absolute inset-0 flex items-center justify-center text-blue-600">
            <Mail className="w-10 h-10" />
          </div>
          <div className="absolute bottom-0 right-0 bg-green-500 text-white p-1.5 rounded-full border-4 border-white">
            <CheckCircle2 className="w-5 h-5" />
          </div>
        </div>

        {/* Content */}
        <div className="space-y-4">
          <h1 className="text-3xl font-bold text-slate-900">בדוק את המייל שלך</h1>
          <p className="text-slate-600 text-lg leading-relaxed">
            שלחנו קישור לאישור החשבון לכתובת:
            <br />
            <span className="font-bold text-slate-900 mt-1 block">{email}</span>
          </p>
          <div className="bg-slate-50 border border-slate-100 rounded-xl p-4 text-sm text-slate-500 text-right">
            <p className="font-bold mb-1 text-slate-700">לא קיבלת את המייל?</p>
            <ul className="list-disc list-inside space-y-1">
              <li>בדוק את תיקיית הספאם (דואר זבל) או קידומי מכירות.</li>
              <li>המתן מספר דקות, לעיתים זה לוקח זמן.</li>
            </ul>
          </div>
        </div>

        {/* Actions */}
        <div className="pt-4 flex flex-col gap-3">
          <Button asChild className="w-full h-12 rounded-xl bg-slate-900 hover:bg-slate-800 text-base">
            <Link to="/login">
              עבור להתחברות
            </Link>
          </Button>
          <Button asChild variant="ghost" className="w-full h-12 rounded-xl text-slate-500 hover:text-slate-900">
            <Link to="/" className="gap-2">
              <ArrowRight className="w-4 h-4" />
              חזרה לדף הבית
            </Link>
          </Button>
        </div>

      </div>
    </div>
  );
};

export default VerificationPending;